import React, {PropTypes} from 'react';
import {ListItem} from 'material-ui/List';
import { VideoIcon, TakeActionIcon } from '../Icons';
import ContentItemAction from './ContentItemAction';
import IsReadTitle from './IsReadTitle';

const VideoItem = ({item}) => {
  return (
    <div>
      <ContentItemAction>
        <ListItem primaryText={<IsReadTitle title={item.title} read={item.read}/>}
          leftIcon={<VideoIcon />}
          rightIcon={<TakeActionIcon />}
          item={item}
        />
      </ContentItemAction>
    </div>
  );
};

VideoItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    read: PropTypes.boolean
  })
};

export default VideoItem;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/VideoItem.js
 **/